import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI } from '../../../types/default-cloud-graph-video-entity-ati';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { NounSubtypeKey, TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { ForgePioGoogleDriveIcon, ForgePioGoogleDriveSearchResultIcon } from './icon';

export const forgePioGoogleDriveConfig: ThirdPartyConfig = {
	displayName: 'Google Drive by Pio',
	id: 'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
	resourceType: ProductResourceTypes3P.ForgePioGoogleDriveProd,
	icon: get3PLogo(ForgePioGoogleDriveIcon, 'ForgePioGoogleDrive', 'medium'),
	searchResultIcon: get3PLogo(ForgePioGoogleDriveSearchResultIcon, 'ForgePioGoogleDrive', 'large'),
	integrationAri: 'ari:cloud:platform::integration/pcIwW04B398CSnilRIyzPJ5v5GevlCCo',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Video,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_VIDEO_ENTITY_ATI,
				subTypes3P: [NounSubtypeKey.Video],
			},
		],
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
